import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Typography, Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import TextsmsIcon from "@mui/icons-material/Textsms";
import { reset as userReset } from "../../redux/userSlice";
import { reset as insuranceReset } from "../../redux/insuranceSlice";
import { reset as stripeReset } from "../../redux/stripeSlice";
import Question from "../../components/Question";
import InfoCard from "../../components/InfoCard";
import { handleContactCareTeam } from "../../lib/utils";

export default function PaymentSuccess(props) {
  const dispatch = useDispatch();

  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("sm"));


  useEffect(() => {
    dispatch(userReset());
    dispatch(insuranceReset());
    dispatch(stripeReset());
  }, [dispatch]);

  return (
    <Question
      noBack={true}
      backgroundColor="#82B1FF33"
      componentHeight="100vh"
      title="Payment received"
      input={
        <>
          <InfoCard
            icon={CheckCircleOutlineIcon}
            title="Payment status"
            description="Your payment has been received. Our team will continue processing your case."
          />

          <Typography variant="body2" color="text.secondary" mb={2}>
            You can close this page now. If you need help, you can text the care team.
          </Typography>

          <Stack
            direction="column"
            spacing={2}
            mt={2}
            sx={{
              width: "100%",
              alignItems: "center",
            }}
          >
            <Button
              fullWidth
              variant="outlined"
              startIcon={<TextsmsIcon />}
              onClick={handleContactCareTeam}
              sx={{
                width: isDesktop ? "50%" : "100%",
                borderColor: "piction.highlight",
                backgroundColor: "piction.highlight",
                color: "white",
                borderRadius: "20px",
                fontFamily: "Inter, sans-serif",
                fontWeight: 600,
                px: 2.5,
                "&:hover, &:active, &:focus": {
                  backgroundColor: "piction.highlight",
                  borderColor: "piction.highlight",
                  color: "white",
                  boxShadow: "none",
                },
              }}
            >
              Text Us
            </Button>
          </Stack>
        </>
      }
      {...props}
    />
  );
}